/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".presets-container[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:pointer;padding-right:1rem}"];
export { styles as styles };

